export const GET_PRIVATE_RESERVATIONS = 'GET_PRIVATE_RESERVATIONS';
export const GET_RESERVATION_SUGGESTED_SEATS =
  'GET_RESERVATION_SUGGESTED_SEATS';
